// import { get } from '@rails/request.js'

// // turbo_fetch.js
// export async function turboFetch(url, method = 'GET', body = null) {
//   const headers = {
//     'Accept': 'text/vnd.turbo-stream.html',
//     'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
//   };

//   if (body && !(body instanceof FormData)) {
//     headers['Content-Type'] = 'application/json';
//     body = JSON.stringify(body);
//   }

//   const response = await fetch(url, {
//     method,
//     headers,
//     body
//   });

//   if (response.ok) {
//     const html = await response.text();
//     Turbo.renderStreamMessage(html);
//   } else {
//     console.error(`Turbo fetch ${method} to ${url} failed`, response);
//   }
// }

// export async function turboVisit(url, action = "replace", params = {}) {
//   const query = new URLSearchParams(params).toString();
//   if (query) {
//     url += '?' + query;
//   }
//   await get(url, {responseKind: "turbo-stream"});
//   // Turbo.visit(url, {acceptsStreamResponse: true} );
// }

// Turob.visitではなく、getを使う
// X-CSRF-Token用のライブラリ
// https://github.com/hotwired/turbo-rails/issues/460
// https://github.com/rails/request.js

import { FetchRequest } from "@rails/request.js";
import { navigator } from "@hotwired/turbo"

async function turboStreamRequest(url, method = "GET", dataObject = null, withHistory = false) {

  let options = {responseKind: "turbo-stream"};
  if (dataObject) {
    const formData = new FormData();
    for (const key in dataObject) {
      if (dataObject.hasOwnProperty(key)) {
        formData.append(key, dataObject[key]);
      }
    }
    options.body = formData;
  }

  if (withHistory) {
    const protocol = location.protocol;
    const host = location.host;
    const destUrl = `${protocol}//${host}` + url;
    //Turbo の履歴管理を使用して pushState を行う
    console.log("pushState", destUrl);
    navigator.history.push(new URL(destUrl));
  }

  const request = new FetchRequest(method, url, options);
  const response = await withProgress(request.perform());
  console.log("Turbo Stream リクエスト成功", response);

  if (!response.ok) {
    console.error("Turbo Stream リクエスト失敗", response);
  }
  document.dispatchEvent(new Event('turboStreamRequest'));
  return response;
}

function showProgressBar() {
  navigator.delegate.adapter.progressBar.setValue(0)
  navigator.delegate.adapter.progressBar.show()
}

function hideProgressBar() {
  navigator.delegate.adapter.progressBar.setValue(1)
  navigator.delegate.adapter.progressBar.hide()
}

export function withProgress(request) {
  showProgressBar()

  return request.then((response) => {
    hideProgressBar()
    return response
  })
}

export async function turboVisit(url, withHistory = false) {
  //暫定：ドロップダウンを非表示にする
  const dropdowns = document.querySelectorAll('.dropdown-content');
  if (dropdowns.length > 0) {
    dropdowns.forEach((dropdown) => {
      dropdown.style.display = 'none';
      setTimeout(() => { dropdown.style.display = ''; }, 100);
    });
  }
  return turboStreamRequest(url, "GET", null, withHistory);
}

export async function turboPut(url, params) {
  return turboStreamRequest(url, "PUT", params);
}

export async function turboPost(url, params) {
  return turboStreamRequest(url, "POST", params);
}

export async function turboPatch(url, params) {
  return turboStreamRequest(url, "PATCH", params);
}

export async function turboDelete(url) {
  return turboStreamRequest(url, "DELETE");
}

/**
 * ブラウザバックはリロード
 * turbostreamのstateとalpinejsは復元できないため
 */
window.addEventListener("popstate", (event) => {
  location.reload();
});